<script setup>
    import AlertListItem from '@/components/shared/AlertListItem.vue'
    import Alert from '@/utils/Alert'
    import { router, usePage } from '@inertiajs/vue3'
    import { onUnmounted, ref, watch } from 'vue'

    const processedPageId = ref(null)

    // Watch for alert prop changes and process them
    watch(
        () => usePage().props.alert,
        (newAlert) => {
            if (newAlert && newAlert.type && newAlert.type !== '') {
                Alert.add({
                    type: newAlert.type,
                    title: newAlert.title || '',
                    description: newAlert.description || '',
                })
            }
        },
        { immediate: true }
    )

    // Listen for successful navigation to clear processed alerts
    const removeNavigationListener = router.on('success', (event) => {
        // Clear old processed alerts when navigating to a new page
        // This prevents memory leaks while maintaining duplicate protection
        const currentPageId = event.detail.page.url
        if (processedPageId.value !== currentPageId) {
            processedPageId.value = currentPageId

            // Clear very old processed alerts (older than 30 seconds)
            const thirtySecondsAgo = Date.now() - 30000
            const oldAlerts = Array.from(Alert.processedAlerts).filter((id) => {
                const timestamp = parseInt(id.split('_').pop()) * 2000
                return timestamp < thirtySecondsAgo
            })

            oldAlerts.forEach((id) => Alert.processedAlerts.delete(id))
        }
    })

    onUnmounted(() => {
        removeNavigationListener()
    })

    function remove(index) {
        Alert.remove(index)
    }
</script>
<template>
    <TransitionGroup
        tag="div"
        enter-from-class="translate-x-full opacity-0"
        enter-active-class="duration-700"
        leave-active-class="duration-700"
        leave-to-class="translate-x-full opacity-0"
        class="fixed right-4 bottom-4 z-1002 w-full max-w-[25rem] space-y-4"
    >
        <AlertListItem
            v-for="(item, index) in Alert.items"
            :key="item.key"
            :message="item"
            :duration="3000"
            @remove="remove(index)"
        />
    </TransitionGroup>
</template>
